// Native
import { useState } from "react"
import { Badge, Box, Flex, FormatNumber, Grid, GridItem, HStack, LocaleProvider, Progress, Spinner, Text } from "@chakra-ui/react"

// Custom
import { Form, Parts, UI } from "components"
import { Styles } from "config"
import useDownlines from "hooks/useDownlines"
import useUser from "hooks/useUser"

import DialogDownline from './downline'

export default function Points(){

    const user = useUser()
    const downlines = useDownlines()
    const [ dialogDownline, setDownline ] = useState(false)

    const [ hidden_expired, setHiddenExpired ] = useState(false)

    const career = user.data?.consultant?.career?.current_career

    return(
    <>
    <DialogDownline open={!!dialogDownline} data={dialogDownline} onClose={() => setDownline(false)} />

    <UI.Header title="Pontuação" />

    <Grid templateColumns={{ sm: '1fr', md: 'repeat(2, 1fr)', lg: 'repeat(3, 1fr)' }} gap={4}>

        <GridItem><Parts.Widgets.Points /></GridItem>

        <GridItem><Parts.Widgets.Pin.Details /></GridItem>

        <GridItem><Parts.Widgets.Anticipations /></GridItem>

    </Grid>

    <Flex w="100%" justifyContent="space-between" alignItems="center" my={4}>
        <Text color="GrayText" my={4}>Downlines diretos:</Text>
        <Box>
            <Form.Checkbox label="Ocultar usuários expirados" value={hidden_expired} onChange={e => setHiddenExpired(e.target.checked)} />
        </Box>
    </Flex>

    <UI.Show visible={downlines.isFetching}><UI.Alert indicator={<Spinner />} my={4} size="sm" colorPalette="gray" title="Carregando seus downlines..." /></UI.Show>

    <Grid templateColumns={{ sm: '1fr', md: 'repeat(2, 1fr)', lg: 'repeat(3, 1fr)' }} gap={4}>

        { downlines.data?.map(item => {

            const pinStyle = Styles.pin(item.career?.id)
            const active_month = Styles.activeMonth(item.active_month_status)
            const progress_style = Styles.percentage_vme(item.vme.percentage)

            if(hidden_expired == 1 && item.name === 'Usuário Expirado') return <></>

            return(
            <GridItem key={item.id}>
                <UI.Pressable onClick={() => setDownline(item)}>
                    <Box py={2} px={4} borderRadius={4} backgroundColor="bg.subtle">
                        <HStack gap={4}>
                            <Box>
                                <UI.Avatar src={item.avatar_url} name={item.name} size="md" colorPalette={active_month.colorPalette} borderWidth={2} borderColor={`${active_month.colorPalette}.muted`} />
                            </Box>
                            <Box w="100%">
                                <Badge colorPalette={pinStyle.colorPalette}>{item.career?.title}</Badge>
                                <Text fontSize="sm">{item.name}</Text>
                                <Progress.Root striped animated defaultValue={item.vme?.percentage} size="xs" maxW="lg" mt={2} colorPalette={progress_style.colorPalette}>
                                    <Progress.Track flex="1"><Progress.Range /></Progress.Track>
                                    <Flex justifyContent="space-between" gap="2">
                                        <Text fontSize="xs" fontWeight="300"><LocaleProvider locale="de-DE"><FormatNumber value={item.points.qualified / 100} /></LocaleProvider></Text>
                                        <Text fontSize="xs" fontWeight="300"><LocaleProvider locale="de-DE"><FormatNumber value={career?.vme / 100} /></LocaleProvider></Text>
                                    </Flex>
                                </Progress.Root>
                            </Box>
                        </HStack>
                    </Box>
                </UI.Pressable>
            </GridItem>
            )
        })}


    </Grid>
    </>
    )
}
